// Generated by scripts/generate-app-version.mjs. Do not edit manually.
export const APP_VERSION = {
  "version": "0.5.5",
  "commit": "cbd448b",
  "dirty": false,
  "builtAt": "2026-10-02T17:02:30.647Z",
  "buildId": "cbd448b-20261002T170230647Z"
} as const;
